var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
var SvgTextAttachment = function (props) { return (_jsx("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 18 18", width: "1em", height: "1em" }, props, { children: _jsx("path", { stroke: "currentColor", strokeMiterlimit: 10, strokeWidth: 1.25, d: "M4.75 9.607h3.643a2.025 2.025 0 0 0 0-4.048h-3.44a3.443 3.443 0 0 0-3.434 3.672c.118 1.83 1.72 3.21 3.55 3.21h7.862c1.834 0 3.433-1.385 3.55-3.21a3.443 3.443 0 0 0-3.433-3.672h-.81" }) }))); };
export default SvgTextAttachment;
